const ComeDown = ({ makeList }) => {
  return (
    <>
      <img
        src="./sort-down.svg"
        alt="come down button"
        tabIndex="0"
        className="comeDown"
      />
    </>
  );
};

export default ComeDown;
